import {defineStore} from 'pinia'

export const useModalStatusStore = defineStore('modalStatusStore', {
    persist: true,
    state: () => ({
        leadModalIsVisible: false,
        catalogModalIsVisible: false,
        clippyModalIsVisible: false,
        actFastModalIsVisible: false,
        actFastModalClosedByHuman: false,
        endOfSeasonPromoModalShouldShow: true
    }),

    actions: {
        showLeadModal() {
            this.leadModalIsVisible = true
        },

        hideLeadModal() {
            this.leadModalIsVisible = false
        },

        showCatalogModal() {
            this.catalogModalIsVisible = true
        },

        hideCatalogModal() {
            this.catalogModalIsVisible = false
        },

        showClippyModal() {
            this.clippyModalIsVisible = true
        },

        hideClippyModal() {
            this.clippyModalIsVisible = false
        },

        showActFastModal() {
            this.actFastModalIsVisible = true
        },

        hideActFastModal() {
            this.actFastModalIsVisible = false
        },

        hideActFastModalByHuman() {
            this.actFastModalClosedByHuman = true
            this.actFastModalIsVisible = false
        },

        showEndOfSeasonPromoModal() {
            this.endOfSeasonPromoModalShouldShow = true
        },

        hideEndOfSeasonPromoModal() {
            this.endOfSeasonPromoModalShouldShow = false
        }
    }
})
